export default __webpack_public_path__ + "img/Linth.eaca57f9.png";